import {
  Input, ComponentRef, ViewContainerRef,
  ComponentFactoryResolver, Directive, OnDestroy,
} from '@angular/core'

import {GenericTextboxComponent} from './generic-textbox/generic-textbox.component'

import {TranslocoService} from "@ngneat/transloco";
import {Subscription} from "rxjs"
import {
  extProfileMapping,
  keyDefMapping
} from 'app/modules/landing-publication/ext-profiles/types/ext-profile-component-mapping'

@Directive({
  standalone: true,
  selector: '[appExt]'
})
export class ExtProfileDirective implements OnDestroy {

  dynamicExtComponent: ComponentRef<any>;
  curLang: string;
  displayDebug: boolean;

  private subs$: Subscription = new Subscription()

  constructor(
    private containerRef: ViewContainerRef,
    private resolver: ComponentFactoryResolver,
    public translocoService: TranslocoService
  ) {
  }

  @Input() set appExt(ext: any) {

    this.containerRef.clear();

    const isRandom = ext?.data?.randomAssignement;

    const keyDef = ext?.data?.keyDef;
    const keyName = ext?.keyname;

    let componentName

    if (!keyName || !keyDef) {

      console.error('[extProfile.directive] No keyname found:', ext);

    }

    componentName = extProfileMapping[keyName]

    if (keyDef === 'SelectFx') {
      componentName = keyDefMapping['SelectBt']
    }

    if (!componentName) {
      componentName = keyDefMapping[keyDef]
    }

    if (isRandom) {
      componentName = GenericTextboxComponent;
    }

    if (componentName) {

      this.buildComponent(componentName, keyName);

      if (this.dynamicExtComponent.instance) {

        //
        //
        this.dynamicExtComponent.instance.curLang = this.curLang;
        this.dynamicExtComponent.instance.displayDebug = this.displayDebug;
        //
        //
      }

    } else {

      console.error(`[extProfile.directive] Component not found for ${keyDef} -> ${keyName}`);

    }

  }

  buildComponent(componentType: any, keyName: string) {

    let factory = this.resolver.resolveComponentFactory(componentType);
    this.dynamicExtComponent = this.containerRef.createComponent(factory);
    this.dynamicExtComponent.instance.keyname = keyName;

    this.setupSubscribers()
  }

  ngOnDestroy(): void {
    this.subs$.unsubscribe()
  }

  private setupSubscribers() {
    const langSub$ = this.translocoService.langChanges$.subscribe((aLang) => {
      this.curLang = aLang
      this.dynamicExtComponent.instance.curLang = this.curLang
    })

    this.subs$.add(langSub$)
  }


}
